import React from 'react';
import { Text, View } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { NavigationContainer } from '@react-navigation/native';

import { AuthProvider } from './app/context/AuthContext';
import RootNavigator from './app/index';
import { linking } from './app/navigation/linking';
import { navigationRef } from './app/navigation/navRef';
import { initInsights, trackNavigation } from './app/insights/beacon';
import { initAppInsights } from './app/insights/appInsights';

// App Insight interne (CCT-193, Phase 2) : beacon + listeners globaux, AVANT tout rendu
// (donc avant toute auth). Best-effort, non bloquant.
initInsights();


// SDK JS Application Insights (CCT-193) — WEB UNIQUEMENT : pages vues / sessions /
// utilisateurs / navigateur / géo / fetch-XHR / exceptions + corrélation W3C vers les
// backends OTel. Sur mobile natif, ce module est un STUB no-op (le SDK n'est pas dans
// le bundle) : le beacon ci-dessus reste le seul chemin, inchangé.
initAppInsights();

class ErrorBoundary extends React.Component<{children: React.ReactNode}, {error: Error | null}> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error) { console.error('App Error:', error); }
  render() {
    if (this.state.error) {
      return (
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 20 }}>
          <Text style={{ color: 'red', fontSize: 16, fontWeight: 'bold' }}>Something went wrong</Text>
          <Text style={{ marginTop: 10, color: '#333' }}>{this.state.error.message}</Text>
          <Text style={{ marginTop: 10, color: '#666', fontSize: 12 }}>{this.state.error.stack?.slice(0, 500)}</Text>
        </View>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <GestureHandlerRootView style={{ flex: 1 }}>
        <AuthProvider>
          <NavigationContainer
            ref={navigationRef}
            linking={linking}
            onReady={() => trackNavigation(navigationRef.getCurrentRoute()?.name)}
            onStateChange={() => trackNavigation(navigationRef.getCurrentRoute()?.name)}
          >
            <RootNavigator />
          </NavigationContainer>
        </AuthProvider>
      </GestureHandlerRootView>
    </ErrorBoundary>
  );
}
